export function formatDate(value: string | null): string {
  if (!value) return "\u2014";
  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/**
 * Format a moment as YYYY-MM-DD in the reader's own timezone — the date a person in the
 * room would say it happened. For a full timestamp (`frozenAt`); a date-only column should
 * use the digits it already has.
 */
export function formatDateYMD(value: string | null): string {
  if (!value) return "\u2014";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "\u2014";
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * Format a date as MM/DD/YYYY. Accepts either a date-only ISO string ("YYYY-MM-DD", e.g.
 * a `commitDate`) or a full ISO timestamp ("YYYY-MM-DDTHH:mm:ss.sssZ", e.g. `addedAt`) \u2014
 * either way, only the date part is shown.
 *
 * Reads the year/month/day straight off the string's leading digits instead of going
 * through `Date` + `toLocaleDateString`, which resolve in the *browser's* local timezone \u2014
 * a UTC-midnight `commitDate` would otherwise roll back a day for any reader west of UTC.
 */
export function formatDateMDY(value: string | null): string {
  if (!value) return "\u2014";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return "\u2014";
  const [, year, month, day] = match;
  return `${month}/${day}/${year}`;
}
